import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc5c45be&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/InputComponent/index.vue').default,SelectComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SelectComponent/index.vue').default,DatePickerComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/DatePickerComponent/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default,AccountAgencyOrder: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AccountAgencyOrder/index.vue').default,RoundButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RoundButton/index.vue').default,Empty: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Empty/index.vue').default,Divider: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Divider/index.vue').default})
